import { useEffect, useState } from 'react';

/**
 * performance-design-web-oberflaeche, Abschnitt "Rendering- und
 * Interaktionspfade": Lade-/Skeleton-Schwelle von 150ms, damit sehr schnelle
 * Antworten nicht zu einem Flackern des Skeleton-Zustands führen.
 */
export function useDelayedFlag(flag: boolean, delayMs = 150): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!flag) {
      setDelayed(false);
      return;
    }
    const timer = window.setTimeout(() => setDelayed(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [flag, delayMs]);

  return flag && delayed;
}
